/** Отдача файла родителю. Отдельным модулем, чтобы экран проверялся без
 *  настоящего `URL.createObjectURL`: в jsdom его нет, и любой тест выгрузки
 *  падал бы не по делу. */
export function downloadJson(name: string, data: unknown): void {
  const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.append(link);
  link.click();
  link.remove();
  /** Ссылка на объект держит содержимое файла в памяти вкладки, пока её не
   *  отпустят. Журнал за год занятий — это мегабайты. */
  URL.revokeObjectURL(url);
}
